import(/* webpackMode: "eager" */ "/repo/apps/web/src/app/error.tsx");
